<template>
  <h1 class="pageHeader">販売ご利用ガイド</h1>
  <section class="guides_wrapper">
    <div class="local_nav">
      <div class="local_nav_row">
        <NuxtLink to="#about">会社情報</NuxtLink>
        <NuxtLink to="#terms">利用条件</NuxtLink>
        <NuxtLink to="#delivery">送料・配送方法</NuxtLink>
        <NuxtLink to="#payment">支払方法</NuxtLink>
      </div>
      <div class="local_nav_row">
        <NuxtLink to="#date">発送・到着日</NuxtLink>
        <NuxtLink to="#cancel">注文キャンセル</NuxtLink>
        <NuxtLink to="#returns">返品・交換</NuxtLink>
        <NuxtLink to="#migration">会員引継ぎ</NuxtLink>
      </div>
    </div>

    <section id="about">
      <h2>会社情報</h2>
      <section>
        <div>
          <h3>カーナベル株式会社</h3>
          <p class="address">〒510-0064　三重県四日市市新正4丁目6-8<br>カーナビルディング 1F〜5F</p>
        </div>
        <div class="photos_wrapper">
          <div class="photos">
            <div><img src="https://assets.ka-nabell.com/selling-web/guides/img-about01.jpg" alt="カーナベル - 玄関" width="193" height="128"></div>
            <div> <img src="https://assets.ka-nabell.com/selling-web/guides/img-about02.jpg" alt="カーナベル - 査定" width="193" height="128"></div>
          </div>
          <div class="photos">
            <div><img src="https://assets.ka-nabell.com/selling-web/guides/img-about03.jpg" alt="カーナベル - 封入" width="193" height="128"></div>
            <div><img src="https://assets.ka-nabell.com/selling-web/guides/img-about04.jpg" alt="カーナベル - 職場" width="193" height="128"></div>
          </div>
        </div>
        <NuxtLink to="https://about.ka-nabell.com/" target="_blank">
          <Button text="カーナベル コーポレートサイト" width="100%" />
        </NuxtLink>
      </section>
    </section>

    <section id="terms">
      <h2>利用条件</h2>
      <section>
        <ul class="list">
          <li>商品金額の合計が2,000円以上より購入可能です。</li>
          <li>ご購入いただくには<TextLink :to="signinLink" text="会員登録" size="lg" inline  />が必要です。</li>
        </ul>
      </section>
    </section>

    <section id="delivery">
      <h2>送料・配送方法</h2>
      <section>
        <p>送料は基本的に無料です。宅急便で送る場合のみ600円（※北海道・沖縄のみ 1,200円）かかります。</p>

        <section>
          <h3>ネコポス</h3>
          <table>
            <tbody>
              <tr>
                <th>送料</th>
                <td>
                  150円<br>
                  ※注文金額4,000円以上で無料<br>
                  （当社負担）
                </td>
              </tr>
              <tr>
                <th>日時指定</th>
                <td>不可</td>
              </tr>
              <tr>
                <th>代金引換</th>
                <td>不可</td>
              </tr>
              <tr>
                <th>受取方法</th>
                <td>ポスト投函</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <h3>宅急便</h3>
          <table>
            <tbody>
              <tr>
                <th>送料</th>
                <td>600円<br>※北海道・沖縄のみ 1,200円</td>
              </tr>
              <tr>
                <th>日時指定</th>
                <td>可</td>
              </tr>
              <tr>
                <th>代金引換</th>
                <td>可</td>
              </tr>
              <tr>
                <th>受取方法</th>
                <td>対面</td>
              </tr>
            </tbody>
          </table>
        </section>
      </section>
    </section>

    <section id="payment">
      <h2>支払方法</h2>
      <section>
        <table>
          <tbody>
            <tr>
              <th>支払方法</th>
              <th>手数料</th>
            </tr>
            <tr>
              <td>クレジットカード</td>
              <td>0円</td>
            </tr>
            <tr class="paypay">
              <td>PayPay</td>
              <td>0円</td>
            </tr>
            <tr>
              <td>代金引換<br>（宅急便のみ可能）</td>
              <td>400円<br>※商品受取時に現金でお支払いください</td>
            </tr>
            <tr>
              <td>リニューアル前サイトの<br>ポイント利用</td>
              <td>0円<br>※ポイント利用の<br>詳細は<TextLink to="https://gachi-matome.com/p-pcg-news-20241202/" size="sm" mode="external" target="_blank" text="こちら" inline /></td>
            </tr>
          </tbody>
        </table>
        <section>
          <h3>ご利用可能なクレジットカード決済</h3>
          <p>日本国内で発行されたカードのみご利用できます。</p>
        </section>
      </section>
    </section>

    <section id="date">
      <h2>発送・到着日</h2>
      <section>
        <section>
          <h3>発送日</h3>
          <table>
            <tbody>
              <tr>
                <th>注文完了時間</th>
                <th>当社発送日</th>
              </tr>
              <tr>
                <td>15:00まで</td>
                <td>当日発送</td>
              </tr>
              <tr>
                <td>15:00以降</td>
                <td>翌日発送</td>
              </tr>
            </tbody>
          </table>
          <p>毎日発送しています。日曜・祝・お盆・年末も営業。<br>（年始1月1日〜1月3日のみ、お休みいただきます）</p>
        </section>
        <section>
          <h3>到着日</h3>
          <p class="mbSS">発送より1〜3日以内に到着します。</p>
          <ul class="notice_list">
            <li>※到着までの日数は、配送方法・配送場所によって異なります</li>
            <li>※離島については、さらに数日かかる場合があります</li>
          </ul>
          <div class="ex_link">
            <TextLink to="https://www.kuronekoyamato.co.jp/ytc/customer/send/search/payment/" mode="external" size="xs" target="_blank" text="料金・お届け予定日を調べる（ヤマト運輸サイトへ）" class="yamato_link" />
          </div>
        </section>
        <section>
          <h3>日時指定</h3>
          <p>宅急便の場合は、日時指定が可能です。<br>指定可能日は、最短日時から4日間までです。注文時間や地域によって最短日時が異なりますので、購入時にご確認ください。</p>
        </section>
      </section>
    </section>

    <section id="cancel">
      <h2>注文キャンセル</h2>
      <section>
        <section>
          <div>
            <p class="mbSS">当社の発送作業に入るまではキャンセル可能です。発送作業に入るとキャンセルできません。</p>
            <ul class="notice_list">
                <li>※商品単体でのキャンセルは不可</li>
            </ul>
          </div>
          <p>下記画像のように、「注文済」の状態であればキャンセル手続きを行うことができます。</p>
        </section>
        <img src="https://assets.ka-nabell.com/selling-web/guides/img-cancel.jpg" alt="キャンセル説明" class="cancel_image" width="398" height="223" >
        <section>
          <h3>キャンセル方法</h3>
          <p>マイページの<TextLink :to="sellingOrdersLink" text="購入履歴詳細" size="lg" inline  />から、注文状況を確認し「この注文を取消」よりキャンセルできます。</p>
        </section>
      </section>
    </section>

    <section id="returns">
      <h2>返品・交換</h2>
      <section>
        <section>
          <h3>お客様都合の返品・交換</h3>
          <p>商品の性質上、お客様の都合による返品はお受けできません。</p>
        </section>
        <section>
          <h3>注文内容と異なる商品が到着した場合</h3>
          <p>商品到着から2日以内に、<TextLink :to="contactLink" text="お問合せフォーム" size="lg" inline  />から下記内容を添えてご連絡ください。早急に対応します。</p>
          <ul class="returns_list">
            <li>氏名</li>
            <li>注文した商品名／状態／枚数</li>
            <li>到着した商品の商品名／状態／枚数</li>
          </ul>
          <p class="mbS">お問合せいただいた後、当社より返送用キットを送付します。そちらに商品を入れてお送りいただきます。<br>当社に商品が到着後、商品違いを確認できましたら、交換対応します。
          </p>
          <ul class="notice_list">
            <li>可能な限り、商品が入れられていたスリーブのまま返送キット入れてお送りください</li>
            <li>在庫がなければ、返金で対応いたします</li>
            <li>送料は当社負担いたします</li>
          </ul>
        </section>
        <section>
          <h3>注文数より少ない枚数が到着した場合</h3>
          <p>商品到着から2日以内に、<TextLink :to="contactLink" text="お問合せフォーム" size="lg" inline  />から下記内容を添えてご連絡ください。早急に対応します。</p>
          <ul class="returns_list">
            <li>氏名</li>
            <li>注文した商品名／状態／枚数</li>
            <li>到着した枚数</li>
          </ul>
          <p class="mbS">お問合せいただいた後、当社にて調査を行います。当社の手違いが確認されましたら、追加で商品を送付します。</p>
          <ul class="notice_list">
            <li>在庫がなければ、返金で対応いたします</li>
            <li>送料は当社負担いたします</li>
          </ul>
        </section>
        <section>
          <h3>状態違いと思われる場合</h3>
          <p>状態は当社独自の基準によりランク分けしています。状態違いと思われる方は、まずは<TextLink to="/pokemon/conditions" text="カードの状態" size="lg" inline  />
            ページをご確認ください。</p>
          <p>そのうえで差異があると感じられた場合は、商品到着から2日以内に、<TextLink :to="contactLink" text="お問合せフォーム" size="lg" inline  />から下記内容を添えてご連絡ください。
          </p>
          <ul class="returns_list">
            <li>氏名</li>
            <li>注文した商品名／状態／枚数</li>
            <li>状態違いだと思われる理由</li>
          </ul>
          <p class="mbS">
            お問合せいただいた後、当社より返送用キットを送付します。そちらに商品を入れてお送りいただきます。<br>当社に商品が到着後、商品違いを確認できましたら、交換対応いたします。
          </p>
          <ul class="notice_list">
            <li>可能な限り、商品が入れられていたスリーブのまま返送キット入れてお送りください</li>
            <li>在庫がなければ、返金で対応いたします</li>
            <li>送料は当社負担いたします</li>
          </ul>
        </section>
      </section>
    </section>

    <section id="migration">
      <h2>会員引継ぎ</h2>
      <p>
        2024年11月20日のサイトリニューアルに際し、リニューアル前サイトから会員情報を引き継ぎできず、申し訳ございません。
        新たに会員登録をお願いいたします。<br/>
        <br/>
        なお、リニューアル前サイトで獲得したお買物ポイントは、今後も引き続きご利用いただけます。<br/>
        <TextLink to="https://gachi-matome.com/p-pcg-news-20241202/" mode="external" inline size="lg" target="_blank" text="お買物ポイントの利用方法" />
      </p>
    </section>

    <section>
      <h2>お問合せ</h2>
      <p>上記内容で解決しなかった場合は、お問合せフォームからご連絡ください。</p>
      <NuxtLink :to="contactLink">
        <Button text="お問合せフォーム" width="100%" />
      </NuxtLink>
    </section>

    <div class="link_top">
      <TextLink mode="arrow" text="ポケカ販売トップ" to="/pokemon" />
    </div>

    <!-- TODO: パンくずリストの設定 -->

  </section>
</template>

<script lang="ts">
import { useProfileWeb } from "@/composables/useProfileWeb";
import { TextLink, Button } from "@ka-nabellinc/ka-nabell-ui";
export default defineNuxtComponent({
  components: {
    TextLink,
    Button,
  },
  setup() {
    const { signinLink, sellingOrdersLink, contactLink } = useProfileWeb();
    return { signinLink, sellingOrdersLink, contactLink };
  },
});
</script>

<style scoped>
.pageHeader {
  width: 100%;
}

h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.3px;
}

table {
  border-collapse:collapse;
  border-spacing:0;
}

p {
  color: var(--semantic-colors-text-black);
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.14px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

li {
  color: var(--semantic-colors-text-black);
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.14px;
}

a {
  color: var(--semantic-colors-text-link);
  text-decoration: underline;
}

.guides_wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.guides_wrapper>section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  scroll-margin-top: calc(56px + 10px); /* ヘッダーの高さ + 調整 */
}

.guides_wrapper>section>section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.guides_wrapper>section>section>section {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.address {
  margin-top: 8px;
}

.local_nav {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.local_nav_row {
  display: flex;
  align-items: center;
}

.local_nav_row a {
  font-size: 11px;
  line-height: 24px;
  padding: 1px 12px;
  letter-spacing: 0.11px;
  line-height: 1.6;
  border-right: 1px var(--semantic-colors-background-gray) solid;
  color: var(--semantic-colors-text-black);
  text-decoration: none;
  white-space: nowrap;
}

.local_nav_row a:last-child {
  border-right: none;
}

.photos_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
}

.photos {
  display: flex;
  gap: 12px;
}

.photos > div{
    flex: 1;
}

.photos img {
    width:100%;
    height: auto;
    vertical-align: middle;
}

.list li {
  margin-left: 24px;
  list-style: disc;
}

.notice_list li {
  font-size: 13px;
  line-height: 150%;
  letter-spacing: 0.13px;
  list-style: disc;
  margin-left: 1rem;
}

#cancel .notice_list {
  margin-top: 4px;
}

.cancel_image {
  width: 100%;
  height: auto;
}

table {
  width: 100%;
  font-size: 11px;
}

th {
  width: 140px;
  padding: 1em;
  border: 1px #D7D7D7 solid;
  background: var(--primitive-colors-basic-yellow-100);
  text-align: center;
  vertical-align: middle;
  line-height: 160%;
  letter-spacing: 0.11px;
}

#payment th, #date th {
  width: 50%;
}

td {
  padding: 1em;
  border: 1px #D7D7D7 solid;
  text-align: center;
  line-height: 160%;
  letter-spacing: 0.11px;
}

.yamato_link{
  line-height: 150%;
  letter-spacing: 0.11px;
}

.ex_link {
  font-size: 11px;
  text-align: right;
}

.ex_link a {
  color: var(--semantic-colors-text-black);
}

.returns_list {
  padding: 12px 16px;
  background: var(--semantic-colors-background-lightgray);
}

.returns_list li {
  font-size: 12px;
  margin-left: 20px;
  list-style: disc;
  line-height: 150%;
  letter-spacing: 0.12px;
}

.link_top {
  color: var(--semantic-colors-text-black);
  font-size: 13px;
  align-self: center;
}

.paypay {
  height: 64px;
}
</style>